export const enum GdprVertical {
    Deh = "deh",
    Kasa = "kasa",
    SazkaBet = "sazkabet",
}
